import React from 'react'

import { GameWithUserInformation } from 'containers/GamesBlock/types'

import { Favorite } from './Favorite'
import { GameState } from './GameState'
import { Name, TitleBox } from './styles'

interface Props {
  game: GameWithUserInformation
  onClick?: () => void
}

export function Title({ game, onClick }: Props) {
  const { name } = game

  return (
    <TitleBox>
      <GameState game={game} />
      <Name onClick={onClick}>{name}</Name>
      <Favorite game={game} />
    </TitleBox>
  )
}
